import React,{useEffect, useState} from "react";
import AOS from 'aos';
import { ClipLoader } from "react-spinners";
import './App.css';
import  "./navbarHead/navbarHead.css"
import  "./portfolioAboutMe/portfolAbout.css"
import  "./contact_footer/contactFooter.css"
import 'aos/dist/aos.css';
import { Navbar, Head, Portfolio, Aboutme , Contact, Footer} from './component';

console.log(window.innerWidth);

function App() {
  const [loading,setLoading] = useState(false)
  useEffect(() => {
    AOS.init(
      {
        duration: 500,
        easing: "linear"
      }
    );
  }, [])
  useEffect(()=>{
    setLoading(true)
    setTimeout(() => {
        setLoading(false)
    }, 2000);
  },[])
  return (
   
    <div className="App">
       {
      loading ?
          <div className="cliploader" >
            <ClipLoader
          
          color={"#BF7506"}
          loading={true}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
          speedMultiplier={1}


          />
          </div>
      :
        <div className='max_width'>
            <Navbar />
            <Head />
            <Portfolio />
            <Aboutme />
            <Contact />
            <Footer />
        </div>
      }
        
    </div>
  );
}

export default App;
